var map = {
	"./about-disabled.svg": "38a1",
	"./bank-disabled.svg": "6065",
	"./binary-disabled.svg": "9c19",
	"./clipboard-disabled.svg": "3563",
	"./coding-disabled.svg": "a25c",
	"./door-disabled.svg": "21bb",
	"./doors-disabled.svg": "9698",
	"./graph-disabled.svg": "89e1",
	"./numbered_list-disabled.svg": "15a1",
	"./tag-disabled.svg": "472d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3e7d";